export const visit = (vm, at) => {
vm(require("./availability/ja.lyaml"));
vm(require("./typical-response-time/ja.lyaml"));
vm(require("./default/ja.lyaml"));
at({ "ja": { "conversations-internal-schema": { "we-wont-use-this-key-in-the-product-but-this-file-wont-update-with-new-languages-without-a-key": "OK" } } });
};